<div class="search flex-col">
  <div class="search-form flex-row flex-wrap space-between">
    <div class="search-form-fields flex-row flex-wrap gap-20 flex-start fx-flex-100">
      <ng-content></ng-content>
    </div>
  </div>
</div>
